import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "desktop-betting-section" }
const _hoisted_2 = { class: "desktop-betting-header" }
const _hoisted_3 = { class: "desktop-section-title" }
const _hoisted_4 = { class: "desktop-tab-navigation" }
const _hoisted_5 = {
  key: 0,
  class: "desktop-tab-content active-tab-content"
}
const _hoisted_6 = { class: "desktop-market-dropdown-section" }
const _hoisted_7 = { class: "desktop-dropdown-container" }
const _hoisted_8 = { class: "desktop-dropdown-label" }
const _hoisted_9 = { value: "" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "desktop-number-selection-section"
}
const _hoisted_12 = { class: "desktop-number-selection-header" }
const _hoisted_13 = { class: "desktop-number-selection-title" }
const _hoisted_14 = {
  key: 0,
  class: "desktop-number-selection-odds"
}
const _hoisted_15 = {
  key: 0,
  class: "desktop-number-grid"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "desktop-number-grid"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 2,
  class: "desktop-bonus-section"
}
const _hoisted_20 = { class: "desktop-bonus-title" }
const _hoisted_21 = {
  key: 0,
  class: "desktop-bonus-number-grid"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "desktop-market-info" }
const _hoisted_24 = { class: "desktop-market-text" }
const _hoisted_25 = {
  key: 0,
  class: "desktop-market-odds"
}
const _hoisted_26 = {
  key: 1,
  class: "desktop-action-buttons"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 1,
  class: "desktop-tab-content active-tab-content"
}
const _hoisted_29 = { class: "desktop-bonus-markets" }
const _hoisted_30 = { class: "desktop-bonus-group-title" }
const _hoisted_31 = { class: "desktop-bonus-markets-grid" }
const _hoisted_32 = { class: "desktop-bonus-market-header" }
const _hoisted_33 = { class: "desktop-bonus-market-description" }
const _hoisted_34 = { class: "desktop-bonus-outcomes" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "desktop-bonus-outcome-label" }
const _hoisted_37 = { class: "desktop-bonus-outcome-odds" }

import { ref, computed, watch } from 'vue';
import { formatOdds } from '../../utils/currency';
import { getMarketDisplayLabel } from '../../utils/market';


const __default__ = {
  name: "DesktopBettingSection",
};

interface MarketOutcome {
  id: number;
  text: string;
  select_numbers: boolean;
  pick: number;
  slug: string;
  odds: string;
  specifier: string | null;
}

interface Market {
  id: number;
  name: string;
  slug: string;
  description: string;
  ordering: number;
  outcomes: MarketOutcome[];
}

interface MarketGroup {
  id: number;
  name: string;
  slug: string;
  ordering: number;
  has_bonus: boolean;
  markets: Market[];
  rules: Array<{
    id: number;
    name: string;
    balls_min: number;
    balls_max: number;
    picks_min: number;
    picks_max: number;
    has_bonus: number | boolean;
    max_resulted: number;
    type: string;
  }>;
}

interface SelectedMarket {
  marketGroup: MarketGroup;
  market: Market;
  label: string;
  odds: number;
  select_numbers: boolean;
  balls: number;
  outcome_id: string;
}

interface Props {
  bettingMarkets: MarketGroup[];
  selectedMarket: SelectedMarket | null;
  hotNumbers?: number[];
  coldNumbers?: number[];
  betslipLength: number;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    bettingMarkets: {},
    selectedMarket: {},
    hotNumbers: {},
    coldNumbers: {},
    betslipLength: {}
  },
  emits: ["select-market", "remove-market", "toggle-group", "tab-changed", "add-line", "remove-line", "add-to-betslip", "clear-all"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Tab state
const activeTab = ref<'main' | 'bonus'>('main');

// Main market selection
const selectedMainMarket = ref<number | ''>('');
const selectedBonusMarkets = ref<Array<{ market: Market; outcome: MarketOutcome }>>([]);

// Number selection state
const selectedNumbers = ref<number[]>([]);
const selectedBonusNumbers = ref<number[]>([]);
const lines = ref<Array<{ numbers: number[]; bonus?: number; numBets: number; picks: number }>>([]);

// Quick pick pattern memory
const lastQuickPickPattern = ref<{ mainCount: number; bonusCount: number } | null>(null);

// Computed properties to separate markets
const mainMarkets = computed(() => {
  return props.bettingMarkets.filter(group => 
    group.markets.some(market => 
      market.outcomes.some(outcome => outcome.select_numbers)
    )
  );
});

const bonusMarkets = computed(() => {
  return props.bettingMarkets.map(group => ({
    ...group,
    markets: group.markets.filter(market => 
      market.outcomes.every(outcome => !outcome.select_numbers)
    )
  })).filter(group => group.markets.length > 0);
});

const allMainMarkets = computed(() => {
  const markets: Market[] = [];
  mainMarkets.value.forEach(group => {
    group.markets.forEach(market => {
      if (market.outcomes.some(outcome => outcome.select_numbers)) {
        markets.push(market);
      }
    });
  });
  
  return markets.sort((a, b) => {
    const isABonusBallSameDrum = a.slug === 'bonus-ball-bet-same-drum-as-standard-numbers';
    const isBBonusBallSameDrum = b.slug === 'bonus-ball-bet-same-drum-as-standard-numbers';
    
    if (isABonusBallSameDrum && !isBBonusBallSameDrum) return 1;
    if (!isABonusBallSameDrum && isBBonusBallSameDrum) return -1;
    return 0;
  });
});

const selectedMainMarketData = computed(() => {
  return allMainMarkets.value.find(market => market.id === selectedMainMarket.value);
});

const selectedMainMarketGroup = computed(() => {
  return mainMarkets.value.find(group => 
    group.markets.some(market => market.id === selectedMainMarket.value)
  );
});

// Ballset calculations
const actualBallsMax = computed(() => {
  if (selectedMainMarketGroup.value?.rules?.length) {
    const mainRule = selectedMainMarketGroup.value.rules.find(rule => rule.type === 'main' || !rule.has_bonus);
    return mainRule ? mainRule.balls_max : 49;
  }
  return 49; // Default
});

const actualBalls = computed(() => {
  if (selectedMainMarketData.value?.outcomes) {
    const firstOutcome = selectedMainMarketData.value.outcomes.find(outcome => outcome.select_numbers);
    return firstOutcome ? firstOutcome.pick : 5;
  }
  return 5; // Default
});

const bonusBallsMax = computed(() => {
  if (isSameDrumMarket.value) {
    return actualBallsMax.value;
  }
  if (selectedMainMarketGroup.value?.rules?.length) {
    const bonusRule = selectedMainMarketGroup.value.rules.find(rule => rule.has_bonus === 1);
    return bonusRule ? bonusRule.balls_max : 20;
  }
  return 20; // Default
});

const maxSelectableBalls = computed(() => {
  if (selectedMainMarketData.value?.outcomes) {
    const maxPick = Math.max(...selectedMainMarketData.value.outcomes
      .filter(outcome => outcome.select_numbers)
      .map(outcome => outcome.pick)
    );
    return maxPick || actualBallsMax.value;
  }
  return actualBallsMax.value;
});

const requiresBonusBall = computed(() => {
  return selectedMainMarketGroup.value?.has_bonus || false;
});

const isBonusOnlyMarket = computed(() => {
  const slug = selectedMainMarketGroup.value?.slug;
  return slug === 'bonus-ball-only-same-drum' || 
         slug === 'bonus-ball-only-additional-drum';
});

const isSameDrumMarket = computed(() => {
  const slug = selectedMainMarketGroup.value?.slug;
  return slug === 'standard-bet-and-bonus-ball-same-drum' ||
         slug === 'bonus-ball-only-same-drum' ||
         slug === 'standard-bet-bonus-from-same-drum' ||
         slug === 'regular-numbers-plus-bonus-ball-same-drum';
});

const isSameDrumBonusMarket = computed(() => {
  const slug = selectedMainMarketGroup.value?.slug;
  return slug === 'bonus-ball-only-same-drum' ||
         slug === 'standard-bet-bonus-from-same-drum';
});

const isMainIncludingBonusMarket = computed(() => {
  const slug = selectedMainMarketGroup.value?.slug;
  return slug === 'standard-bet-bonus-from-same-drum';
});

const canAddLine = computed(() => {
  if (isBonusOnlyMarket.value) {
    return selectedBonusNumbers.value.length > 0;
  }
  
  // For main including bonus markets, need at least 1 number (1-6 balls allowed)
  if (isMainIncludingBonusMarket.value) {
    return selectedNumbers.value.length >= 1;
  }
  
  // Check for duplicate numbers in same drum markets
  if (isSameDrumMarket.value && !isMainIncludingBonusMarket.value) {
    const hasDuplicates = selectedNumbers.value.some(mainNum => 
      selectedBonusNumbers.value.includes(mainNum)
    );
    if (hasDuplicates) {
      return false;
    }
    
    return selectedNumbers.value.length > 0 && selectedBonusNumbers.value.length > 0;
  }
  
  if (requiresBonusBall.value && !isSameDrumMarket.value) {
    return selectedNumbers.value.length > 0 && selectedBonusNumbers.value.length > 0;
  }
  return selectedNumbers.value.length > 0;
});

// Computed properties for current odds display
const currentOutcome = computed(() => {
  if (!selectedMainMarketData.value || selectedNumbers.value.length === 0) return null;
  
  // For main including bonus markets, use the actual number count
  if (isMainIncludingBonusMarket.value) {
    return selectedMainMarketData.value.outcomes.find(outcome => 
      outcome.select_numbers && outcome.pick === selectedNumbers.value.length
    );
  }
  
  return selectedMainMarketData.value.outcomes.find(outcome => 
    outcome.select_numbers && outcome.pick === selectedNumbers.value.length
  );
});

const currentOdds = computed(() => {
  return currentOutcome.value ? Number(currentOutcome.value.odds) : null;
});

// Use props.hotNumbers and props.coldNumbers if provided
const hotNumbers = computed(() => {
  if (props.hotNumbers && props.hotNumbers.length > 0) {
    return props.hotNumbers;
  }
  return [];
});

const coldNumbers = computed(() => {
  if (props.coldNumbers && props.coldNumbers.length > 0) {
    return props.coldNumbers;
  }
  return [];
});

// Set default market selection
const setDefaultMainMarket = () => {
  if (allMainMarkets.value.length > 0 && !selectedMainMarket.value) {
    selectedMainMarket.value = allMainMarkets.value[0].id;
    onMainMarketChange();
  }
};

// Watch for changes in allMainMarkets to set default when data is available
watch(allMainMarkets, (newMarkets) => {
  if (newMarkets.length > 0 && !selectedMainMarket.value) {
    setDefaultMainMarket();
  }
}, { immediate: true });

// Watch for tab changes to clear main market selection when switching to bonus
watch(activeTab, (newTab) => {
  emit('tab-changed', newTab);
  if (newTab === 'bonus') {
    selectedMainMarket.value = '';
  } else if (newTab === 'main' && !selectedMainMarket.value) {
    setDefaultMainMarket();
  }
});

// Initialize default selection
setDefaultMainMarket();

const onMainMarketChange = () => {
  // Clear all number selections when market changes
  selectedNumbers.value = [];
  selectedBonusNumbers.value = [];
  lines.value = [];
  
  if (selectedMainMarket.value && selectedMainMarketData.value && selectedMainMarketGroup.value) {
    // Find the first outcome with select_numbers for this market
    const firstOutcome = selectedMainMarketData.value.outcomes.find(outcome => outcome.select_numbers);
    if (firstOutcome) {
      const marketData: SelectedMarket = {
        marketGroup: selectedMainMarketGroup.value,
        market: selectedMainMarketData.value,
        label: formatOutcomeText(firstOutcome),
        odds: Number(firstOutcome.odds),
        select_numbers: firstOutcome.select_numbers,
        balls: firstOutcome.pick,
        outcome_id: firstOutcome.id.toString()
      };
      emit('select-market', marketData);
    }
  }
};

const selectBonusMarket = (market: Market, outcome: MarketOutcome, group: MarketGroup) => {
  // Check if this market/outcome is already selected
  const isAlreadySelected = selectedBonusMarkets.value.some(selected => 
    selected.market.id === market.id &&
    selected.outcome.id === outcome.id
  );
  
  if (isAlreadySelected) {
    // Remove from selection (toggle off)
    selectedBonusMarkets.value = selectedBonusMarkets.value.filter(selected => 
      !(selected.market.id === market.id &&
        selected.outcome.id === outcome.id)
    );
    
    // Emit remove event to parent
    emit('remove-market', {
      marketGroup: group,
      market: market,
      label: formatOutcomeText(outcome),
      odds: Number(outcome.odds),
      select_numbers: outcome.select_numbers,
      balls: outcome.pick,
      outcome_id: outcome.id.toString()
    });
  } else {
    // Add to selection (toggle on)
    selectedBonusMarkets.value.push({ market, outcome });
    
    // Emit add event to parent
    emit('select-market', {
      marketGroup: group,
      market: market,
      label: formatOutcomeText(outcome),
      odds: Number(outcome.odds),
      select_numbers: outcome.select_numbers,
      balls: outcome.pick,
      outcome_id: outcome.id.toString()
    });
  }
};

const isMarketSelected = (market: Market, outcome: MarketOutcome): boolean => {
  // Check if this is a bonus market selection
  if (selectedBonusMarkets.value.length > 0) {
    return selectedBonusMarkets.value.some(selected => 
      selected.market.id === market.id &&
      selected.outcome.id === outcome.id
    );
  }
  
  // Check if this is the currently selected main market
  if (selectedMainMarket.value === market.id) {
    return true;
  }
  
  return false;
};

const formatOutcomeText = (outcome: MarketOutcome): string => {
  let text = outcome.text || outcome.id.toString();
  
  // Replace {value} placeholder with specifier value
  if (text.includes('{value}') && outcome.specifier) {
    text = text.replace('{value}', outcome.specifier);
  }
  
  return text;
};

const formatMarketDescription = (market: Market): string => {
  let description = market.description || '';
  
  // Find the first outcome with a specifier to replace {value} in description
  const outcomeWithSpecifier = market.outcomes.find(outcome => outcome.specifier);
  if (outcomeWithSpecifier?.specifier && description && description.includes('{value}')) {
    description = description.replace('{value}', outcomeWithSpecifier.specifier);
  }
  
  return description;
};

const toggleMainIncludingBonusNumber = (number: number) => {
  const index = selectedNumbers.value.indexOf(number);
  
  if (index === -1) {
    // Add number if we have space (max 6 main numbers)
    if (selectedNumbers.value.length < 6) {
      selectedNumbers.value.push(number);
    }
  } else {
    // Remove number and shift remaining numbers
    selectedNumbers.value.splice(index, 1);
  }
  
  // Update market selection with current number count
  updateSelectedMarketForBalls(selectedNumbers.value.length);
};

const toggleNumber = (number: number) => {
  if (isSameDrumMarket.value && selectedBonusNumbers.value.includes(number)) {
    return;
  }
  
  if (selectedNumbers.value.includes(number)) {
    selectedNumbers.value = selectedNumbers.value.filter(n => n !== number);
  } else {
    if (selectedNumbers.value.length < maxSelectableBalls.value) {
      selectedNumbers.value.push(number);
    }
  }
  
  // Update market selection with current number count
  updateSelectedMarketForBalls(selectedNumbers.value.length);
};

const toggleBonusNumber = (number: number) => {
  if (isSameDrumMarket.value && selectedNumbers.value.includes(number)) {
    return;
  }
  
  if (selectedBonusNumbers.value.includes(number)) {
    selectedBonusNumbers.value = selectedBonusNumbers.value.filter(n => n !== number);
  } else {
    // Clear existing selection and select new one
    selectedBonusNumbers.value = [number];
  }
};

const updateSelectedMarketForBalls = (numberOfBalls: number) => {
  if (!selectedMainMarketData.value) return;
  
  // Find the outcome that matches the number of balls selected
  const matchingOutcome = selectedMainMarketData.value.outcomes.find(outcome => 
    outcome.select_numbers && outcome.pick === numberOfBalls
  );
  
  if (matchingOutcome && selectedMainMarketGroup.value) {
    // Update the selected market with the new outcome
    const marketData: SelectedMarket = {
      marketGroup: selectedMainMarketGroup.value,
      market: selectedMainMarketData.value,
      label: formatOutcomeText(matchingOutcome),
      odds: Number(matchingOutcome.odds),
      select_numbers: matchingOutcome.select_numbers,
      balls: matchingOutcome.pick,
      outcome_id: matchingOutcome.id.toString()
    };
    emit('select-market', marketData);
  }
};

const quickPick = () => {
  if (isBonusOnlyMarket.value) {
    // For bonus-only markets, maintain the same number of bonus selections
    const currentBonusCount = selectedBonusNumbers.value.length;
    const targetBonusCount = currentBonusCount > 0 ? currentBonusCount : 1;
    
    const bonusNumbers = Array.from({ length: bonusBallsMax.value }, (_, i) => i + 1);
    const shuffledBonus = bonusNumbers.sort(() => Math.random() - 0.5);
    selectedBonusNumbers.value = shuffledBonus.slice(0, targetBonusCount);
    
    // Store pattern for bonus-only market
    lastQuickPickPattern.value = { mainCount: 0, bonusCount: targetBonusCount };
  } else {
    // For regular markets, 
    let mainCount: number;
    let bonusCount: number;
    
    // If user has existing selections, maintain the same count but clear previous selections
    if (selectedNumbers.value.length > 0 || selectedBonusNumbers.value.length > 0) {
      mainCount = selectedNumbers.value.length > 0 ? selectedNumbers.value.length : actualBalls.value;
      bonusCount = selectedBonusNumbers.value.length > 0 ? selectedBonusNumbers.value.length : 
                   ((requiresBonusBall.value || isSameDrumMarket.value) ? 1 : 0);
      
      // Clear previous selections before picking new ones
      selectedNumbers.value = [];
      selectedBonusNumbers.value = [];
    } else if (lastQuickPickPattern.value) {
      // Use the same pattern as the last quick pick
      mainCount = lastQuickPickPattern.value.mainCount;
      bonusCount = lastQuickPickPattern.value.bonusCount;
    } else {
      // First time - use current market requirements
      mainCount = actualBalls.value;
      bonusCount = (requiresBonusBall.value || isSameDrumMarket.value) ? 1 : 0;
    }
    
    // Quick pick main numbers
    if (mainCount > 0) {
      const availableNumbers = Array.from({ length: actualBallsMax.value }, (_, i) => i + 1);
      const shuffled = availableNumbers.sort(() => Math.random() - 0.5);
      selectedNumbers.value = shuffled.slice(0, mainCount);
    }
    
    // Quick pick bonus numbers (if required)
    if (bonusCount > 0) {
      const bonusNumbers = Array.from({ length: bonusBallsMax.value }, (_, i) => i + 1);
      const availableBonusNumbers = isSameDrumMarket.value 
        ? bonusNumbers.filter(num => !selectedNumbers.value.includes(num))
        : bonusNumbers;
      
      if (availableBonusNumbers.length > 0) {
        const shuffledBonus = availableBonusNumbers.sort(() => Math.random() - 0.5);
        selectedBonusNumbers.value = shuffledBonus.slice(0, bonusCount);
      } else {
        selectedBonusNumbers.value = [];
      }
    }
    
    // Store the pattern for next quick pick
    lastQuickPickPattern.value = { mainCount, bonusCount };
    
    // Update market selection to match the number of balls selected
    updateSelectedMarketForBalls(selectedNumbers.value.length);
  }
};

const addLine = () => {
  if (!canAddLine.value) return;
  
  const line = {
    numbers: [...selectedNumbers.value],
    bonus: (requiresBonusBall.value || (isSameDrumMarket.value && !isMainIncludingBonusMarket.value) || isBonusOnlyMarket.value) ? selectedBonusNumbers.value[0] : undefined,
    numBets: 1,
    picks: selectedNumbers.value.length
  };
  
  lines.value.push(line);
  
  // Store the pattern for future quick picks
  lastQuickPickPattern.value = {
    mainCount: selectedNumbers.value.length,
    bonusCount: selectedBonusNumbers.value.length
  };
  
  // Emit the line to parent
  emit('add-line', line);
  
  // Clear selections for next line
  selectedNumbers.value = [];
  selectedBonusNumbers.value = [];
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const removeLine = (index: number) => {
  lines.value.splice(index, 1);
  emit('remove-line', index);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const clearAll = () => {
  lines.value = [];
  selectedNumbers.value = [];
  selectedBonusNumbers.value = [];
  emit('clear-all');
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const addToBetslip = () => {
  emit('add-to-betslip', lines.value);
};

// Reset quick pick pattern when market changes
watch(selectedMainMarket, () => {
  lastQuickPickPattern.value = null;
});

watch(() => props.betslipLength, (newLength, oldLength) => {
  if (oldLength && oldLength > 0 && newLength === 0) {
    selectedBonusMarkets.value = [];
  }
});

// Reset internal state when market is cleared
watch(() => props.selectedMarket, (newMarket) => {
  if (!newMarket) {
    // Reset all internal state when market is cleared
    selectedNumbers.value = [];
    selectedBonusNumbers.value = [];
    lines.value = [];
    lastQuickPickPattern.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('betting.selectYourMarket')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: _normalizeClass(["desktop-tab-btn", { active: activeTab.value === 'main' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'main'))
      }, _toDisplayString(_ctx.$t('betting.mainMarkets')), 3),
      _createElementVNode("button", {
        class: _normalizeClass(["desktop-tab-btn", { active: activeTab.value === 'bonus' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'bonus'))
      }, _toDisplayString(_ctx.$t('betting.bonusMarkets')) + " 🎁 ", 3)
    ]),
    (activeTab.value === 'main')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('betting.selectMarket')) + ":", 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedMainMarket).value = $event)),
                onChange: onMainMarketChange,
                class: "desktop-market-select"
              }, [
                _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t('betting.chooseMarket')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allMainMarkets.value, (market) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: market.id,
                    value: market.id
                  }, _toDisplayString(_unref(getMarketDisplayLabel)(market)), 9, _hoisted_10))
                }), 128))
              ], 544), [
                [_vModelSelect, selectedMainMarket.value]
              ])
            ])
          ]),
          (selectedMainMarketData.value && selectedMainMarketData.value.outcomes.some(outcome => outcome.select_numbers))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('betting.selectNumbers')), 1),
                  (currentOdds.value && selectedNumbers.value.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('betting.odds')) + ": " + _toDisplayString(_unref(formatOdds)(currentOdds.value)), 1))
                    : _createCommentVNode("", true)
                ]),
                (!isBonusOnlyMarket.value && !isMainIncludingBonusMarket.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actualBallsMax.value, (n) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: n,
                          class: _normalizeClass(["desktop-number-circle", {
              selected: selectedNumbers.value.includes(n),
              hot: hotNumbers.value.includes(n),
              cold: coldNumbers.value.includes(n),
              disabled: (isSameDrumMarket.value) && selectedBonusNumbers.value.includes(n),
              'quick-pick': selectedNumbers.value.includes(n) && selectedNumbers.value.length === actualBalls.value,
            }]),
                          onClick: ($event: any) => (toggleNumber(n))
                        }, _toDisplayString(n), 11, _hoisted_16))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (isMainIncludingBonusMarket.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actualBallsMax.value, (n) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: n,
                          class: _normalizeClass(["desktop-number-circle", {
              selected: selectedNumbers.value.includes(n),
              hot: hotNumbers.value.includes(n),
              cold: coldNumbers.value.includes(n),
              'quick-pick': selectedNumbers.value.includes(n) && selectedNumbers.value.length >= 1,
            }]),
                          onClick: ($event: any) => (toggleMainIncludingBonusNumber(n))
                        }, _toDisplayString(n), 11, _hoisted_18))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                ((requiresBonusBall.value || isSameDrumMarket.value || isBonusOnlyMarket.value) && selectedMainMarket.value && !isMainIncludingBonusMarket.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(isSameDrumBonusMarket.value ? '' : (isBonusOnlyMarket.value ? _ctx.$t('betting.selectBonusNumber') : _ctx.$t('betting.bonusNumber'))), 1),
                      (!isSameDrumBonusMarket.value || isBonusOnlyMarket.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bonusBallsMax.value, (n) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `bonus-${n}`,
                                class: _normalizeClass(["desktop-number-circle desktop-bonus-circle", {
                selected: selectedBonusNumbers.value.includes(n),
                hot: hotNumbers.value.includes(n),
                cold: coldNumbers.value.includes(n),
                disabled: (isSameDrumMarket.value) && selectedNumbers.value.includes(n),
              }]),
                                onClick: ($event: any) => (toggleBonusNumber(n))
                              }, _toDisplayString(n), 11, _hoisted_22))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["desktop-market-display", { 'center-layout': !((isBonusOnlyMarket.value && selectedBonusNumbers.value.length > 0) || (!isBonusOnlyMarket.value && selectedNumbers.value.length > 0)) }])
                  }, [
                    _createElementVNode("span", _hoisted_24, [
                      (isMainIncludingBonusMarket.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (selectedNumbers.value.length === 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('betting.pleaseSelectNumbers')), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('betting.selectedBalls', { count: selectedNumbers.value.length })), 1)
                                ], 64))
                          ], 64))
                        : ((isBonusOnlyMarket.value && selectedBonusNumbers.value.length > 0) || (!isBonusOnlyMarket.value && selectedNumbers.value.length > 0))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(isBonusOnlyMarket.value 
                  ? _ctx.$t('betting.selectedBonusBalls', { count: selectedBonusNumbers.value.length })
                  : _ctx.$t('betting.selectedBalls', { count: selectedNumbers.value.length })), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('betting.pleaseSelectNumber')), 1)
                            ], 64))
                    ]),
                    (selectedNumbers.value.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(formatOdds)(currentOdds.value)), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ]))
            : _createCommentVNode("", true),
          (selectedMainMarket.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("button", {
                  class: "desktop-quick-pick-btn",
                  onClick: quickPick
                }, _toDisplayString(_ctx.$t('betting.quickPick')), 1),
                _createElementVNode("button", {
                  class: "desktop-add-line-btn",
                  disabled: !canAddLine.value,
                  onClick: addLine
                }, _toDisplayString(_ctx.$t('betting.addLine')), 9, _hoisted_27)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (activeTab.value === 'bonus')
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bonusMarkets.value, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                key: group.id,
                class: "desktop-bonus-group"
              }, [
                _createElementVNode("div", _hoisted_30, _toDisplayString(group.name), 1),
                _createElementVNode("div", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.markets, (market) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: market.id,
                      class: "desktop-bonus-market-item"
                    }, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(getMarketDisplayLabel)(market)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(market.outcomes, (outcome) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: outcome.id,
                            class: _normalizeClass(["desktop-bonus-outcome", { 'selected': isMarketSelected(market, outcome) }]),
                            onClick: ($event: any) => (selectBonusMarket(market, outcome, group))
                          }, [
                            _createElementVNode("span", _hoisted_36, _toDisplayString(formatOutcomeText(outcome)), 1),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(formatOdds)(parseFloat(outcome.odds))), 1)
                          ], 10, _hoisted_35))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})